<template>
	<div class="page-dashboard relative">
		<div class="container-fluid">
			<h2 class="text-primary mb-4">{{ $t('Categories') }}</h2>
			<!-- Table Menu -->
			<div class="table-menu flex-center">
				<div>
					<button
						class="btn btn-submit btn-default"
						@click="addItem">
						{{ $t('Add Category') }}
					</button>
				</div>
				<!-- counting -->
				<div class="mr-3 ml-a">
					<md-menu md-align-trigger md :md-offset-x=10>
						<button class="btn-icon btn p-0 m-0 w-100 btn-click" md-menu-trigger>
								{{ page * limit - (limit - 1) }} - {{ items.length > 0 ? page * limit : items.length }} of {{ totalItems }}
						</button>
						<!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
						<md-menu-content>
							<md-menu-item @click="changeLimit(10)"><span class="text-center minw-50">10</span></md-menu-item>
							<md-menu-item @click="changeLimit(25)"><span class="text-center minw-50">25</span></md-menu-item>
							<md-menu-item @click="changeLimit(50)"><span class="text-center minw-50">50</span></md-menu-item>
							<md-menu-item @click="changeLimit(100)"><span class="text-center minw-50">100</span></md-menu-item>
							<md-menu-item @click="changeLimit(200)"><span class="text-center minw-50">200</span></md-menu-item>
						</md-menu-content>
					</md-menu>
				</div>
				<div>
					<input
						type="text"
						class="form-control"
						:placeholder="$t('Search')"
						@input="onKeywordChange"
						v-model="keyword"
					/>
				</div>
			</div>
			<!-- Main Table -->
			<table class="table table-striped mb-4">
				<thead>
					<tr>
						<th >{{ $t('No') }}</th>
						<th>{{ $t('Name') }}</th>
						<th>{{ $t('Type') }}</th>
						<th>{{ $t('Description') }}</th>
						<th width="20%">{{ $t('') }}</th>
					</tr>
				</thead>
				<div class="p-5 text-center absolute" v-if="isFetching">
					<div class="is-loading large"></div>
				</div>
				<tbody>
					<tr
						v-for="(item, index) in items"
						:key="item.id">
						<td @mouseover="itemHover(item)" @mouseleave="itemLeave(item)">{{ index+1 }}</td>
						<td @mouseover="itemHover(item)" @mouseleave="itemLeave(item)">{{ item.name }}</td>
						<td @mouseover="itemHover(item)" @mouseleave="itemLeave(item)">{{ item.type }}</td>
						<td @mouseover="itemHover(item)" @mouseleave="itemLeave(item)">{{ item.description }}</td>
						<td class="btn-action-table" @mouseover="itemHover(item)" @mouseleave="itemLeave(item)">
							<button v-if="hover && hoverItem === item.id && item.id"
								class="btn btn-default btn-icon mr-3"
								@click="editItem(item)">
								<i class="material-icons md-18">edit</i>
							</button>
							<button v-if="hover && hoverItem === item.id && item.id !== 1 && item.id !== 2 && item.id !== 3 && item.id !== 4"
								class="btn btn-danger btn-icon"
								@click="confirmRemoveItem(item)">
								<i class="material-icons md-18">delete</i>
							</button>
						</td>
					</tr>
				</tbody>
			</table>
			<div class="text-center absolute disabled mt-4" v-if="items.length === 0 && !isFetching">{{$t('No Category available')}}</div>
			<!-- Table Pagination -->
			<pagination
				:total-pages="totalPages"
				:current-page="page"
				:last-page="lastPage"
				@select="onPageSelected">
			</pagination>
		</div>

		<!-- Modals -->
		<div class="modals">
			<!-- Category Form -->
			<category-form
				:data="selected"
				@saved="insertItem"
				@close="isFormVisible = false"
				v-if="isFormVisible"
			/>
			<!-- Delete Confirmation -->
			<modal
				size="small"
				@close="isConfirmRemoveVisible = false"
				v-if="isConfirmRemoveVisible && selected">
				<template slot="header">
					<h3>{{ $t('Remove Category') }}</h3>
				</template>
				<template slot="body">
					{{ $t('Are you sure want to delete') }} {{ showModalName(selected.name) }}?
				</template>
				<template slot="footer">
					<div class="w-100 flex-center">
						<button
							class="btn btn-primary"
							:class="{ 'is-loading': isRemoving }"
							@click="removeItem(selected)">
							{{ $t('Remove') }}
						</button>
						<button
							class="btn btn-default"
							@click="isConfirmRemoveVisible = false">
							{{ $t('Cancel') }}
						</button>
					</div>
				</template>
			</modal>
		</div>
	</div>
</template>

<script>
import { mapActions } from 'vuex';
import Modal from '@/components/Modal.vue';
import CategoryForm from '@/components/CategoryForm.vue';
import Pagination from '@/components/Pagination.vue';
import { getAxiosErrorMessage, delay, elpisisString } from '@/lib/helper';
import categoriesApi from '@/api/categories';

export default {
	name: 'Categories',
	components: {
		Modal,
		CategoryForm,
		Pagination,
	},
	data() {
		return {
			page: 1,
			limit: 10,
			orderBy: 'id',
			sortBy: 'asc',
			keyword: '',
			isAll: false,
			items: [],
			selected: null,
			// totalPages: 2,
			totalItems: 0,
			lastPage: 1,
			isFormVisible: false,
			isConfirmRemoveVisible: false,
			isRemoving: false,
			isFetching: false,
			hover: false,
			hoverItem: null,
		};
	},
	methods: {
		itemLeave() {
			this.hover = false;
			this.hoverItem = null;
		},
		itemHover(item) {
			this.hover = true;
			this.hoverItem = item.id;
		},
		...mapActions({
		}),
		fetch(reset = false, page) {
			this.isFetching = true;
			if (reset) {
				this.page = 1;
				this.items = [];
			}
			if (page) this.page = page;
			const params = this.fetchParams;
			const callback = (response) => {
				const items = response.data.data;
				if (items.length < this.limit) this.isAll = true;
				this.items = items;
				this.totalItems = response.data.total;
				this.lastPage = response.data.lastPage;
				this.isFetching = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Categories',
					text: message,
				});
				this.isFetching = false;
			};
			categoriesApi.getList(params, callback, errorCallback);
		},
		onKeywordChange() {
			delay(() => {
				this.fetch(true);
			}, 500);
		},
		insertItem(item) {
			const index = this.items.findIndex(({ id }) => id === item.id);
			if (index === -1) {
				this.items.push(item);
			} else {
				this.$set(this.items, index, item);
			}
		},
		addItem() {
			this.selected = null;
			this.isFormVisible = true;
		},
		editItem(item) {
			this.selected = item;
			this.isFormVisible = true;
		},
		confirmRemoveItem(item) {
			this.selected = item;
			this.isConfirmRemoveVisible = true;
		},
		removeItem(item) {
			this.isRemoving = true;
			const callback = (response) => {
				const message = response.message;
				const index = this.items.findIndex(({ id }) => id === item.id);
				if (index !== -1) {
					this.items.splice(index, 1);
				}
				this.isRemoving = false;
				this.isConfirmRemoveVisible = false;
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Remove Categories',
					text: message,
				});
			};
			const errorCallback = (e) => {
				this.isRemoving = false;
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Remove Categories',
					text: message,
				});
			};
			categoriesApi.delete(item.id, callback, errorCallback);
		},
		onPageSelected(page) {
			this.fetch(true, page);
		},
		showModalName(str) {
			return elpisisString(str);
		},
		changeLimit(value) {
			this.limit = value;
			this.fetch(true);
		},
	},
	computed: {
		fetchParams() {
			const params = {
				page: this.page,
				limit: this.limit,
				order_by: this.orderBy,
				sort_by: this.sortBy,
				// role: this.role,
			};
			const keyword = this.keyword.trim();
			if (keyword !== '') params.keyword = keyword;
			return params;
		},
		totalPages() {
			const total = Math.ceil(this.totalItems / this.limit);
			return total;
		},
	},
	created() {
		this.fetch();
	},
};
</script>
